import types from './RequestStatusType';

export default class RequestStatusTitle {
    static [types.CLOSED] = 'Закрыто';
    static [types.DENIED] = 'Отказано';
    static [types.PAUSED] = 'Приостановлено';
    static [types.REWORK] = 'На уточнении';
    static [types.WORKUP] = 'В работе';
    static [types.FINISH] = 'Выполнено';
}
